module.exports = __webpack_public_path__ + "static/media/ic_male.c1a80f5a.svg";